import React, { FC, Fragment, ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { SGaugeWrapper, SItem } from './styles';

export type GaugeItem = {
    icon: ReactNode;
    color: string;
    label: string;
    count: number;
    tooltip?: ReactNode;
};

type GaugeProps = {
    items: GaugeItem[];
};

const Gauge: FC<GaugeProps> = ({ items }) => {
    if (!items.length) {
        return null;
    }

    const totalCount = items
        .map((item) => item.count)
        .reduce((accumulator: number, currentValue: number): number => accumulator + currentValue);

    return (
        <SGaugeWrapper>
            {!!items.length &&
                items.map((item: GaugeItem, i: number) => {
                    const reactTooltipId = `react-tooltip-${item.label}`;

                    return (
                        <Fragment key={item.label}>
                            { }
                            <SItem
                                backgroundColor={item.color}
                                data-tooltip-id={reactTooltipId}
                                firstItem={!!(i === 0)}
                                lastItem={!!(i === items.length - 1)}
                                 
                                ratio={(item.count * 100) / totalCount}
                            >
                                {item.icon}
                            </SItem>
                            <Tooltip
                                id={reactTooltipId}
                                place="bottom"
                                positionStrategy="fixed"
                                style={{ backgroundColor: item.color, zIndex: 9999 }}
                            >
                                {item.tooltip || <span>{`${item.label}: ${item.count}`}</span>}
                            </Tooltip>
                        </Fragment>
                    );
                })}
        </SGaugeWrapper>
    );
};

export default Gauge;
